import { Flex } from 'antd';
import styled from 'styled-components';

export const Container = styled(Flex).attrs({ vertical: true })`
  width: 100%;
  max-width: 1248px;
  margin: 0 auto;
  @media (max-width: 1288px) {
    margin: 0 20px;
  }
`;

export const TypeTitle = styled.p`
  margin: 0;
  font-size: 18px;
  font-weight: 500;
  line-height: 28px;
  color: #78797d;
`;
